import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../global/hooks';
import {
	selectActiveSectionId,
	selectActiveSectionRepeatIndex,
	selectMode,
	setActiveSectionId,
	setView
} from '../../store/appSlice';
import { Section } from '../../types';
import { RepeatIndicator, SectionRepeatCount } from './styles';

interface Props {
	section: Section;
}
export default function SectionFooter({ section }: Props) {
	const dispatch = useDispatch();
	const isAppPlaying = useAppSelector(selectMode) === 'play';
	const handleEditSection = () => {
		dispatch(setActiveSectionId(section.id));
		dispatch(setView('editSection'));
	};

	const isSectionCurrentlyPlaying = useAppSelector(selectActiveSectionId) === section.id;
	const activeSectionRepeatIndex = useAppSelector(selectActiveSectionRepeatIndex);
	const currentRepeatIndex =
		isAppPlaying && isSectionCurrentlyPlaying ? activeSectionRepeatIndex : 0;

	return section.repeatCount > 1 ? (
		<SectionRepeatCount
			onClick={handleEditSection}
			title={`Currently on repeat ${currentRepeatIndex + 1} of ${section.repeatCount}`}
		>
			{Array.from(Array(section.repeatCount).keys()).map(i => (
				<RepeatIndicator active={i === currentRepeatIndex} key={i}>
					<span>{i + 1}</span>
				</RepeatIndicator>
			))}
		</SectionRepeatCount>
	) : null;
}
